<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {OrderSummaryMixin} from '@/components/booking/mixins/OrderSummaryMixin.vue'

    @Component
    export class ActivityOrderSummaryMixin extends OrderSummaryMixin {
        get orderTotalPrice() {
            return activitiesStore.orderTotalPrice(
                this.offer,
                this.prebooked,
                this.selectedAddOns,
                this.prepareBookResponse
            )
        }
    }

    export default ActivityOrderSummaryMixin
</script>
